import { track } from '@opallabs/quanta'

/**
 * @typedef {Object} Data
 * @property {string} layout
 * @property {number} presentationId
 */

/**
 * @param {Data} dataToTrack
 * @returns void
 */
export const trackCanvasSlideCreation = (dataToTrack) => {
  const { layout, presentationId } = dataToTrack

  track('Presentation: Create Canvas Slide', {
    'Slide Type': layout,
    'Presentation Id': presentationId,
  })
}

/**
 * @param {Data} dataToTrack
 * @returns void
 */
export const trackCanvasSlideUpdate = (dataToTrack) => {
  const { layout, presentationId } = dataToTrack

  track('Presentation: Update Canvas Slide', {
    'Slide Type': layout,
    'Presentation Id': presentationId,
  })
}
